import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

interface LegacyRedirectProps {
  /** Куда вести. Поддерживает шаблон `{{param}}` из параметров маршрута */
  to: string;
}

/**
 * Редирект со старых адресов, которые появились, когда тема жила в URL.
 * Такие ссылки уже попали в индекс и в чужие материалы, поэтому их нельзя
 * просто удалить — нужно аккуратно свести на канонический адрес.
 */
export default function LegacyRedirect({ to }: LegacyRedirectProps) {
  const navigate = useNavigate();
  const params = useParams();
  const { hash, search } = useLocation();

  useEffect(() => {
    const resolved = to.replace(
      /\{\{(\w+)\}\}/g,
      (match, key: string) => params[key] ?? ""
    );
    navigate(`${resolved}${search}${hash}`, { replace: true });
  }, [to, params, hash, search, navigate]);

  return null;
}
